import * as Sentry from "@sentry/react";
Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN || "https://212122",
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || "production",
    // Adds request headers and IP for users, for more info visit:
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
    sendDefaultPii: true,
    // Enable logs to be sent to Sentry
    enableLogs: true,
});
